import {parseISO, isBefore, startOfDay} from 'date-fns'
import {
  Recurrence,
  Entry,
  Experience,
} from '@wix/ambassador-table-reservations-v1-experience/types'

const isEntryInPast = (entry: Entry): boolean => {
  const today = startOfDay(new Date())

  if (entry.recurrence === Recurrence.ONE_TIME) {
    const startDate = entry.oneTimeOptions?.startDate
    return startDate ? isBefore(parseISO(startDate), today) : false
  }

  const endDate = entry.weeklyOptions?.endDate
  return endDate ? isBefore(parseISO(endDate), today) : false
}

export const isExperienceInPast = (experience: Experience): boolean => {
  const entries = experience.configuration?.onlineReservations?.businessSchedule?.entries
  if (!entries || entries.length === 0) {
    return false
  }
  return entries.every(isEntryInPast)
}
